import { IInterest, IUsageType } from "api/types";
import { useAppState } from "AppState";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import WizardButtonGroup from "components/common/WizardButtonGroup/WizardButtonGroup";
import { ButtonGroup } from "components/common/WizardButtonGroup/WizardButtonGroup.style";

import UsageTypeSelector from "components/ElementSelector/ElementSelector";
import UsageTypes from "components/ElementSelector/UsageTypes/UsageTypes";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import React, { useContext } from "react";
import { Routes } from "router";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import styled from "styled-components";
import useReactRouter from "use-react-router";

export default function UsageTypeSelection(): JSX.Element {
  const {
    locationName,
    availableUsageTypes,
    availableInterests,
    selectedUsageTypeIds,
    setSelectedUsageTypeIds
  } = useAppState();
  const tabletData = useContext(TabletDataContext);
  const {
    setUsageTypes: setUsageTypesInOnboarding
  } = OnboardingContainer.useContainer();
  const { history } = useReactRouter();

  const setSelectedUsageTypes = (changedUsageTypes: IUsageType[]) => {
    setSelectedUsageTypeIds(
      changedUsageTypes.filter(x => x.checked).map(x => x.id)
    );
    setUsageTypesInOnboarding(changedUsageTypes);
  };
  const goToTcpa = () => history.push(Routes.SignUpTcpa);

  const goToSignUpInterestSelection = () =>
    history.push(Routes.SignUpInterestSelection);

  const goToSignUpCustomerPersonalInfo = () =>
    history.push(Routes.SignUpCustomerPersonalInfo);

  return (
    <PanelLayout
      title={locationName}
      titleSecondary="What are your interests?"
      centerContent
    >
      <Container>
        <UsageTypeSelector
          title="Choose Your Cannabis Type"
          allElements={availableUsageTypes}
          initialSelectedIds={selectedUsageTypeIds}
          onChange={setSelectedUsageTypes}
          component={<UsageTypes />}
        />
        <ButtonGroup>
          <WizardButtonGroup
            leftCaption="previous"
            rightCaption={"next"}
            leftClick={goToTcpa}
            rightClick={
              tabletData && tabletData.hasNoInterests
                ? goToSignUpCustomerPersonalInfo
                : goToSignUpInterestSelection
            }
          />
        </ButtonGroup>
      </Container>
    </PanelLayout>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/SignUp/UsageTypeSelection/UsageTypeSelection.tsx